var _ellipse, _mask, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotDataFound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 63,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.539,
    cy: 51.638,
    rx: 58.809,
    ry: 10.76,
    fill: "#F6F8FA"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "not_data_found_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.038 38.752a2.425 2.425 0 110 4.85 2.425 2.425 0 010-4.85z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.463 41.177h-2 2zm-2.425 2.425v-2 2zm0-2.85a2 2 0 000-4v4zm0 0c.235 0 .425.19.425.425h4a4.425 4.425 0 00-4.425-4.425v4zm.425.425c0 .234-.19.425-.425.425v4a4.425 4.425 0 004.425-4.425h-4zm-.425.425a.425.425 0 01-.425-.425h-4a4.425 4.425 0 004.425 4.425v-4zm-.425-.425c0-.235.19-.425.425-.425v-4a4.425 4.425 0 00-4.425 4.425h4z",
    fill: "#9BA7E9",
    mask: "url(#not_data_found_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.038 35.927v-6M83.664 41.29v0a3.548 3.548 0 01-3.174 5.137H63.586v0a3.548 3.548 0 01-3.174-5.136l8.452-16.902v0a3.548 3.548 0 016.348 0l8.452 16.902zM45.038 28.427h15M54.038 28.427v-15M60.038 28.427v-12M48.038 28.427v-9M52.538 40.427h-10.5v0a3 3 0 01-3-3v-33 0a3 3 0 013-3h21.258v0a3 3 0 012.12.878l5.744 5.744v0a3 3 0 01.878 2.12v4.758",
    stroke: "#9BA7E9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgNotDataFound;